<template>
  <div id="app" :class="$WEB.$STORE.state.YeWuYuan == 1 ? 'bj-admin' : ''">
    <router-view />
    <gongyiimg></gongyiimg>
    <sharewx></sharewx>
  </div>
</template>

<script>
import gongyiimg from "@/views/chanpin/components/gongyiimg";
import sharewx from "@/views/chanpin/components/sharewx";

export default {
  name: "App",
  components: { gongyiimg, sharewx },
  data() {
    return {};
  },
  watch: {
    $route(to, from) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      // if (to.path == "/shouye") this.allowBack();
      // console.log(window.location.hash, this.$route.path);
    }
  },
  mounted() {
    //this.allowBack();
  },
  methods: {
    allowBack() {
      console.log(window.location.hash, this.$route.path);
      //禁止浏览器 后退
      if (window.location.hash == "#/shouye") {
        history.pushState(null, null, document.URL);
        window.addEventListener("popstate", function() {
          history.pushState(null, null, document.URL);
        });
      }
    }
  }
  // mounted() {
  //   //禁止 shouye 后退
  //   window.onpopstate = () => {
  //     if (!this.allowBack) {
  //       //    这个allowBack 是存在vuex里面的变量
  //       history.go(1);
  //     }
  //   };
  // }
};
</script>

<style>
body {
  font-family: inherit;
}
.beizhu {
  position: relative;
  top: 50px;
}

.avue-form__group > .el-col-md-24 {
  position: relative !important;
  top: 50px !important;
}
.el-input-group > .el-input__inner {
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 20px !important;
  z-index: 9999;
}
.body_x {
  background: #fff;
  border-top: 3px solid#3c8dbc;
}
.body_x .el-card__body {
  padding: 0 !important;
}
.el-input-group__append {
  border-top-right-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  background: #3c8dbc;
  color: #fff;
}
.el-form--label-top .el-form-item__label {
  padding: 0 !important;
}

.el-menu {
  border-right: solid 0px #e6e6e6;
}
.tan .el-dialog__headerbtn {
  position: absolute;
  top: 0px !important;
  right: -47px !important;
  width: 35px !important;
  height: 35px !important;
  border-radius: 50%;
  font-size: 24px !important;
  background: #fff;
}
.tan .el-dialog__body {
  padding-top: 0 !important ;
  /* padding-bottom:0 !important ; */
}
.el-dialog {
  border-radius: 10px !important;
}
.el-collapse-item__header {
  font-size: 16px !important;
  font-weight: bold !important;
  font-family: "\5FAE\8F6F\96C5\9ED1" !important;
  height: 25px !important;
  padding-left: 5px !important;
  border-left: 5px solid #409eff;
  margin-top: 16px !important;
}
.el-collapse {
  border-top: 0px !important;
}
.elcard .el-card__body {
  padding: 10px !important;
}
.labelForm > .el-form-item__label {
  line-height: 20px !important;
}
.el-menu-item,
.el-submenu__title {
  height: 45px !important;
  line-height: 45px !important;
}
.el-badge__content.is-fixed {
  position: absolute !important;
  top: 8px !important;
  right: 5px !important;
}
.el-drawer.ltr,
.el-drawer.rtl,
.el-drawer__container {
  top: 0 !important;
  bottom: 0 !important;
  height: 100% !important;
  overflow: scroll !important;
  overflow-x: hidden !important;
}
.el-drawer__header {
  margin-bottom: 0px !important;
}

.el-table td,
.el-table th {
  padding: 8px 0;
}
.el-step__title {
  font-size: 14px !important;
}
.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  clear: both;
  visibility: hidden;
}
@media screen and (max-width: 768px) {
  .tan .el-dialog__headerbtn {
    right: 375px !important;
  }
}
.jubu .el-form-item .el-form-item__content,
.dizhi.el-form-item .el-form-item__content {
  line-height: 28px !important;
}
.upload-demo .el-upload-dragger {
  width: 530px !important;
}
.el-aside {
  overflow: hidden !important;
  background-color: rgb(34, 45, 50) !important;
}
.el-aside:hover {
  overflow-y: auto !important;
}

/*滚动条样式*/
::-webkit-scrollbar,
.el-aside::-webkit-scrollbar,
body::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px !important; /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
}
::-webkit-scrollbar-thumb,
.el-aside::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.1);
}
:-webkit-scrollbar-track,
.el-aside::-webkit-scrollbar-track,
body::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  border-radius: 0;
  background: rgba(0, 0, 0, 0);
}
.quanping {
  position: absolute !important;
  top: 10px !important;
  font-size: 24px !important;
  left: 15px !important;
  cursor: pointer !important;
}
.el-drawer__header {
  position: relative !important;
  border-bottom: 1px solid #e8eaec !important;
  padding: 8px 60px !important;
  padding-right: 10px !important;
  line-height: 1 !important;
  margin-bottom: 5px !important;
}
.labelForm > .el-form-item__content {
  /* 画册后工高度 */
  line-height: 25px !important;
}

.van-dialog {
  z-index: 20000 !important;
}
.baojia_title {
  /* background: #409eff; */
  color: #000000 !important;
}
.jiage_sj {
  font-size: 18px !important;
  background: #c6e2ff !important;
}
.jiage_sj .el-button--small {
  font-size: 18px !important;
}
.el-message {
  z-index: 10000 !important;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .el-message-box {
    width: auto !important;
  }
  .el-form-item {
    width: 100% !important;
  }
  .chanpinImg {
    display: none !important;
  }
}

.widthfixls {
  width: 90%;
}
.xlscascader {
  line-height: 24px !important;
}
.xlscascader .el-input__inner {
  color: #323233 !important;
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  /* color: #323233; */
  line-height: inherit;
  height: 24px;
  text-align: left;
  background-color: transparent;
  border: 0;
  resize: none;
}
.xlscascader .el-input__icon {
  display: none;
}
.xlscascader .el-cascader-menu {
  min-width: inherit;
}
.el-cascader-menu {
  min-width: initial;
}
.xlsselect .el-input__inner {
  display: block !important;
  box-sizing: border-box !important;
  width: 100% !important;
  min-width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  color: #323233 !important;
  line-height: inherit !important;
  text-align: left !important;
  background-color: transparent !important;
  border: 0 !important;
  resize: none !important;
  height: 24px;
}
.xlsselect .el-input__icon {
  height: 24px;
  line-height: 24px;
}

.el-collapse-item__wrap {
  overflow: initial !important;
}
.el-main {
  overflow: auto !important;
}
.el-cascader-node {
  display: block;
}

.el-input__inner {
  width: 100%;
  border-radius: 0 !important;
  /* color: #444 !important; */
}
.el-dialog {
  border-radius: 4px !important;
}

.el-select-dropdown__item.selected {
  /* color: #3c8dbc !important; */
  font-weight: 700 !important;
}

.el-tabs__item {
  height: auto !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}

.el-form-item__label,
.labelspan {
  color: #333 !important;
  font-weight: 600 !important;
}
.paddRight {
  padding-right: 3px !important;
  padding-left: 0px !important;
}
.paddLeft {
  padding-right: 0px !important;
  padding-left: 3px !important;
}
.zhanKai .el-form-item__label {
  color: red !important;
}
div:focus,
span:focus {
  outline: none;
}
/* @font-face {
  font-family: "webfont";
  font-display: swap;
  src: url("./css/Alibaba-PuHuiTi-Regular.ttf");
} */

.gongyiimg_show {
  display: none;
}
.phoneNumber {
  color: #409eff;
  border-bottom: 1px solid #409eff;
}
.tabBox {
  position: relative;
}
.tabClose {
  position: absolute;
  top: -22px;
  right: -20px;
}
.addtjty {
  padding: 1px 9px !important;
}
.deltjty {
  padding: 1px 9px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue